import React, { useMemo } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { GridGetterFunction } from '../../../common/components/Grid/GridDataTypes';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { OrderExecutionSearch } from './OrderExecutionSearch';

export const OrdersExecutionSentTab: React.FC = () => {
  const pok = usePokCore();
  const { t, tk } = useTranslation('orderLng');

  const getData = useMemo(
    () =>
      ((
        pageSize,
        pageNumber,
        orderBy,
        orderDirection,
        filterText,
        filterColumns,
      ) =>
        pok.ordersExecution.getAllByPortion(
          t,
          tk,
          pageSize,
          pageNumber,
          orderBy,
          orderDirection,
          filterText,
          filterColumns,
        )) as GridGetterFunction,
    [pok.ordersExecution, t, tk],
  );

  return (
    <OrderExecutionSearch
      getData={getData}
      getCount={pok.ordersExecution.getAllCount}
    />
  );
};
